import { IGameState } from "State/Game/IGameState";
import { IPlayerState } from "State/Player/IPlayerState";
import { getSeasonPassLastSeenProgress } from "State/Player/PlayerSeasonPassHelper";
import { SeasonPassTractorProgress } from "Types/SeasonPass";

/**
 * Return the tractor position from which it should go to the actual one. It's either the position that the player has
 * seen last time, or the 0 position in case the player didn't see the progress before.
 */
export function getCurrentTractorPosition(playerState: IPlayerState, lastSeen = false): SeasonPassTractorProgress {
    if (playerState.seasonPass) {
        if (lastSeen) {
            return getSeasonPassLastSeenProgress(playerState);
        } else {
            return getNextTractorPosition(playerState, lastSeen);
        }
    }
    return { rank: 0, progress: 0 };
}

export function getCurrentTractorInfo(playerState: IPlayerState, rank: number): boolean {
    const currentPosition = getCurrentTractorPosition(playerState);
    let targetRank = currentPosition.rank;
    if (targetRank === rank) {
        return true;
    }
    return false;
}

/** Return the tractor position where it should go to from the current one. */
export function getNextTractorPosition(playerState: IPlayerState, lastSeen = false): SeasonPassTractorProgress {
    if (lastSeen) {
        const currentPosition = getCurrentTractorPosition(playerState);
        if (currentPosition.rank < playerState.seasonPass.currentRank) {
            return { rank: currentPosition.rank + 1, progress: 0 };
        }
    } else {
        return { rank: playerState.seasonPass.currentRank, progress: playerState.seasonPass.progress };
    }
}

export function getLastPositionMinusProgress(playerState: IPlayerState, pointsToSubtract: number): SeasonPassTractorProgress {
    const currentPosition = getCurrentTractorPosition(playerState);
    const ranks = playerState.seasonPass.ranks;
    let { rank, progress } = currentPosition;

    while (pointsToSubtract > 0) {
        if (progress >= pointsToSubtract) {
            progress -= pointsToSubtract;
            pointsToSubtract = 0;
        } else {
            pointsToSubtract -= progress;
            if (rank > 0) {
                rank -= 1;
                progress = ranks[rank].neededProgress;
            } else {
                progress = 0;
                pointsToSubtract = 0;
            }
        }
    }

    return { rank, progress };
}